import { render } from "./Blockquotes.vue?vue&type=template&id=17acd0cd&scoped=true"
import script from "./Blockquotes.vue?vue&type=script&lang=js"
export * from "./Blockquotes.vue?vue&type=script&lang=js"

import "./Blockquotes.vue?vue&type=style&index=0&id=17acd0cd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17acd0cd"

export default script